//
//
//
//
//
//
//
//
//
//

import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import memberModule from '@/common/memberModule';

export default {
  name: 'home',
  metaInfo: {
    title: '华安保险-车险投保',
  },
  data(){
    return{
    }
  },
  components: {
    
  },
  methods: {
    ...mapMutations({
    }),
  },
  created(){
    if (this.$route.query.ARWX && memberModule.accessRecordWeiXin) {
      memberModule.accessRecordWeiXin({productName: '华安保险-车险投保', salesCode: this.$route.query.salesCode});
    }
  }
}


